import { NavLink, Outlet, useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { clsx } from 'clsx'
import { useAuth } from '../lib/useAuth'
import { Spinner } from '../components/ui/Primitives'

const NAV = [
  { to: '/', label: 'Instancias', end: true, cap: null },
  { to: '/servidores', label: 'Servidores', cap: 'server.view' },
  { to: '/dominios', label: 'Dominios', cap: null },
  { to: '/backups', label: 'Backups', cap: null },
  { to: '/usuarios', label: 'Usuarios', cap: 'panel.users.manage' },
  { to: '/auditoria', label: 'Auditoría', cap: 'panel.audit.read' },
]

export default function Layout() {
  const { me, loading, logout, canGlobal } = useAuth()
  const navigate = useNavigate()
  const [dark, setDark] = useState(() => !document.documentElement.classList.contains('light'))

  useEffect(() => {
    if (!loading && !me) navigate('/login', { replace: true })
  }, [loading, me, navigate])

  useEffect(() => {
    document.documentElement.classList.toggle('dark', dark)
    document.documentElement.classList.toggle('light', !dark)
  }, [dark])

  if (loading) {
    return <div className="grid min-h-screen place-items-center"><Spinner className="h-6 w-6" /></div>
  }
  if (!me) return null

  const visible = NAV.filter((n) => n.cap === null || canGlobal(n.cap))

  return (
    <div className="flex min-h-screen flex-col md:flex-row">
      <aside className="flex shrink-0 flex-col border-b md:w-56 md:border-b-0 md:border-r">
        <div className="flex items-center justify-between px-5 py-4">
          <span className="font-semibold">FersaPanel</span>
          <button
            className="rounded p-1.5 text-slate-400 hover:bg-slate-800 hover:text-slate-200"
            onClick={() => setDark((d) => !d)}
            title={dark ? 'Modo claro' : 'Modo oscuro'}
            aria-label="Cambiar tema"
          >
            {dark ? '☀' : '☾'}
          </button>
        </div>

        <nav className="flex gap-1 overflow-x-auto px-3 pb-3 md:flex-col md:overflow-visible">
          {visible.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              className={({ isActive }) =>
                clsx(
                  'whitespace-nowrap rounded-lg px-3 py-2 text-sm transition-colors',
                  isActive ? 'bg-blue-600/15 font-medium text-blue-400' : 'text-slate-400 hover:bg-slate-800/60 hover:text-slate-200',
                )
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="mt-auto hidden border-t px-5 py-4 md:block">
          <p className="truncate text-sm font-medium">{me.user.name}</p>
          <p className="hint truncate">{me.user.email}</p>
          {me.isSuperAdmin && <p className="hint mt-1 text-amber-400">superadministrador</p>}
          <button className="mt-3 text-sm text-slate-400 hover:text-slate-200" onClick={() => void logout()}>
            Cerrar sesión
          </button>
        </div>
      </aside>

      <main className="min-w-0 flex-1 p-5 md:p-8">
        <Outlet />
      </main>
    </div>
  )
}
